export default __webpack_public_path__ + "static/media/05_PFG.28bfb929.png";